module.exports = __webpack_public_path__ + "images/icon_debug_e1a1fa9390cbee06ab669785974eeaec.svg";